export default __webpack_public_path__ + "static/media/welcome-bg.c3e7ec1d.jpg";